import { Component, Inject } from "@angular/core";
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-comfirmation',
  templateUrl: './confirmation.component.html'
})
export class ConfirmationComponent{


  constructor(public dialogRef: MatDialogRef<ConfirmationComponent>,@Inject(MAT_DIALOG_DATA) public data : any){}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
